import { render, staticRenderFns } from "./ColorButtons.vue?vue&type=template&id=0aeed720&"
import script from "./ColorButtons.vue?vue&type=script&lang=js&"
export * from "./ColorButtons.vue?vue&type=script&lang=js&"
import style0 from "./ColorButtons.vue?vue&type=style&index=0&id=0aeed720&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports